/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Radio = require('backbone.radio');
var Ladda = require('ladda');

var FileUploadCollection = require('psa-backbone/models/FileUploadCollection');

var modelGet = require('common/util/modelGet');
var makeUploadCollection = require('common/util/makeUploadCollection');

var HeaderBarView = require('common/views/HeaderBarView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var FileUploadView = require('common/views/FileUploadView');

var SubmitRespondToExternalCorrespondenceTask = require('../../services/SubmitRespondToExternalCorrespondenceTask');

var tmplConSerRespondExternalCorrespondenceTaskView = require('./ConSerRespondExternalCorrespondenceTaskView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerRespondExternalCorrespondenceTaskView,

  className: 'con-ser-respond-correspondence-task-view container-fluid',

  ui: {
    headerBar: '.header-bar-container',
    breadcrumb: '.breadcrumb-container',
    correspondenceForm: '.correspondence-form',
    intFileUploadTableContainer: '.int-file-upload-table-container',
    hasFinDocs: '.has-fin-docs',
    extFileUploadTableContainer: '.ext-file-upload-table-container',
    submit: '.submit'
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    intFileUploadTableContainer: '@ui.intFileUploadTableContainer',
    extFileUploadTableContainer: '@ui.extFileUploadTableContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var correspondence = this.model.get('correspondence') || {};
    var extDocuments = modelGet(this.model, 'correspondence.extDocuments', []);
    var headerBarData = {
      complainantName: correspondence.complainantName || '--',
      entityName: correspondence.entityName || correspondence.complainantEntityName || '--'
    };

    var headerBarColumns = [
      {
        name: 'entityName',
        label: 'Entity Name',
        minWidth: '160px',
        maxWidth: '350px',
        overflow: 'truncate'
      },
      {
        name: 'complainantName',
        label: 'Consumer Name',
        minWidth: '160px',
        maxWidth: '350px',
        overflow: 'truncate'
      }
    ];

    this.showChildView(
      'headerBar',
      new HeaderBarView({
        columns: new Backbone.Collection(headerBarColumns),
        model: new Backbone.Model(headerBarData)
      })
    );

    var getHomeLink = function() {
      return '#conser/my-tasks';
    };

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: getHomeLink(),
            text: 'Home'
          },
          {
            text: 'Respond to Correspondence'
          }
        ]
      })
    );

    Syphon.deserialize(this, correspondence);

    this.extFileUploadTableView = new FileUploadView({
      collection: new FileUploadCollection(extDocuments),
      emptyText: 'No External Documents',
      isReadOnly: true
    });

    this.showChildView('extFileUploadTableContainer', this.extFileUploadTableView);

    this.intFileUploadView = new FileUploadView({
      collection: makeUploadCollection([]),
      isReadOnly: false,
      allowMultipleFiles: true,
      metadata: {
        documentTypeId: 40001
      }
    });

    this.showChildView('intFileUploadTableContainer', this.intFileUploadView);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var complaintId = this.model.get('complaintId');

    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      SubmitRespondToExternalCorrespondenceTask(self.getFormData())
        .done(function() {
          Radio.channel('navigate').trigger('show:int:cs:complaint', complaintId);
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  validate: function() {
    var validationArray = [this.ui.correspondenceForm.parsley().whenValidate(), this.intFileUploadView.validate()];

    return $.when.apply($, validationArray);
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    _.extend(formData, {
      taskId: this.model.get('taskId'),
      correspondenceId: this.model.get('correspondenceId')
    });
    formData.documents = this.intFileUploadView.collection.toJSON();

    return formData;
  }
});
